import api from "../utils/api";

export const getRecipientsWithBalance = async () => {
  try {
    const response = await api.post(
      process.env.VUE_APP_GET_RECIPIENTS_WITH_BALANCE,
      {},
      {
        timeout: 300000, // 5 minutos
      },
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar recebedores com saldo:", error);
    throw error;
  }
};

export const processManualWithdraw = async (payload) => {
  try {
    const response = await api.post(
      process.env.VUE_APP_MANUAL_WITHDRAW,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao processar saques:", error);
    throw error;
  }
};
